module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "order-md3": "",
      "order-xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "white elevation-0"
  }, [_c('v-toolbar-title', {}, [_vm._v("\n                  Appearance Setting\n                ")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Welcome, Feel free to change the logo, color and font styles for your platform\n              ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "fixed": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-0"
  }, [_c('v-tabs-slider', {
    staticClass: "white"
  }), _vm._v(" "), _vm._l((_vm.itemsz), function(i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "href": '#tab-' + i
      }
    }, [_vm._v("\n                          " + _vm._s(i) + "\n                        ")])
  })], 2), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-General"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('General')], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-Landing Page"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('Landing')], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-0",
    attrs: {
      "xs2": "",
      "order-md1": "",
      "order-xs3": ""
    }
  }, [_c('AdminSideBarMenu')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9cb63a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/AppearanceView.vue
// module id = 1729
// module chunks = 9